export function ProductionAnalysisLoading({ mode }: { mode: "summary" | "chart" }) {
  if (mode === "summary") return <>
    <span className="sr-only" role="status">Genel kapsam yükleniyor…</span>
    <div className="pa-factory-metrics" aria-hidden="true">{["Üretim", "Bildirilen duruş", "Iskarta"].map(label => <article key={label} className="pa-factory-metric"><span>{label}</span><div><i className="pa-loading-number" /></div><i className="pa-loading-comparison" /></article>)}</div>
  </>;
  return <div className="pa-loading-chart" aria-hidden="true">
    <div className="pa-loading-toolbar"><div><i /><i /><i /></div><span /></div>
    <div className="pa-loading-plot">
      <div className="pa-loading-guides">{[0, 1, 2, 3, 4].map(tick => <i key={tick} />)}</div>
      {[72, 56, 38, 64].map((width, index) => <div className="pa-loading-row" key={index}>
        <div className="pa-loading-label"><i /><i /></div>
        <div className="pa-loading-track"><span style={{ width: `${width}%` }} /><i /></div>
      </div>)}
    </div>
    <div className="pa-loading-axis">{[0, 1, 2, 3, 4].map(tick => <i key={tick} />)}</div>
  </div>;
}
